import React from "react";

const Subsection = ({item}) => {
    return <>
    <div className="font-bold text-2xl mt-10 text-center text-primary-800">تحت الإنشاء ...</div>
    </>;
};

export default Subsection;
